import caredeskToolkitImage from '@assets/product-caredesk-toolkit.jpg';
import systemDiagnosticsImage from '@assets/product-system-diagnostics.jpg';
import personalCare360Image from '@assets/product-personal-care-360.jpg';
import remoteSupportImage from '@assets/product-remote-support.jpg';
import { oneOffInterventionPaymentLink, personalCare360PaymentLinks, smartCarePaymentLinks, totalCareVipPaymentLinks } from '@config/paymentLinks';
import { calculateProportionalSavings, getMaximumSavingsId } from '@utils/money';
const PERSONAL_CARE_TWELVE_MONTH_PRICE_MINOR = 84900;
const personalCareVariants = [
    {
        id: '36-months',
        durationMonths: 36,
        priceMinor: 160000,
        stripePaymentLink: personalCare360PaymentLinks.thirtySixMonths
    },
    {
        id: '24-months',
        durationMonths: 24,
        priceMinor: 108000,
        stripePaymentLink: personalCare360PaymentLinks.twentyFourMonths
    },
    {
        id: '12-months',
        durationMonths: 12,
        priceMinor: PERSONAL_CARE_TWELVE_MONTH_PRICE_MINOR,
        labelKey: 'personalCare360.noExtraDiscount',
        stripePaymentLink: personalCare360PaymentLinks.twelveMonths
    }
].map((variant) => ({
    ...variant,
    ...calculateProportionalSavings(PERSONAL_CARE_TWELVE_MONTH_PRICE_MINOR, variant.durationMonths, variant.priceMinor)
}));
const personalCareBestValueId = getMaximumSavingsId(personalCareVariants);
export const products = [
    {
        id: 'system-diagnostics',
        slug: 'system-diagnostics',
        nameKey: 'products.oneOffIntervention.name',
        descriptionKey: 'products.oneOffIntervention.description',
        shortDescriptionKey: 'products.oneOffIntervention.shortDescription',
        availability: 'available',
        priceMinor: 9900,
        listPriceMinor: 14900,
        currency: 'EUR',
        image: systemDiagnosticsImage,
        category: 'diagnostics',
        commercial: true,
        fulfilmentType: 'service',
        requestsImmediateStart: true,
        featured: true,
        stripePaymentLink: oneOffInterventionPaymentLink
    },
    {
        id: 'caredesk-toolkit',
        slug: 'caredesk-toolkit',
        nameKey: 'products.caredeskToolkit.name',
        descriptionKey: 'products.caredeskToolkit.description',
        shortDescriptionKey: 'products.caredeskToolkit.shortDescription',
        availability: 'coming_soon',
        currency: 'EUR',
        image: caredeskToolkitImage,
        category: 'software',
        fulfilmentType: 'digital-content',
        featured: false
    },
    {
        id: 'data-manager',
        slug: 'data-manager',
        nameKey: 'products.dataManager.name',
        descriptionKey: 'products.dataManager.description',
        shortDescriptionKey: 'products.dataManager.shortDescription',
        availability: 'coming_soon',
        currency: 'EUR',
        image: caredeskToolkitImage,
        category: 'software',
        fulfilmentType: 'digital-content',
        featured: false
    },
    {
        id: 'password-keeper',
        slug: 'password-keeper',
        nameKey: 'products.passwordKeeper.name',
        descriptionKey: 'products.passwordKeeper.description',
        shortDescriptionKey: 'products.passwordKeeper.shortDescription',
        availability: 'coming_soon',
        currency: 'EUR',
        image: caredeskToolkitImage,
        category: 'software',
        fulfilmentType: 'digital-content',
        featured: false
    },
    {
        id: 'smart-care',
        slug: 'smart-care',
        nameKey: 'products.smartCare.name',
        descriptionKey: 'products.smartCare.description',
        shortDescriptionKey: 'products.smartCare.shortDescription',
        availability: 'available',
        priceMinor: 24900,
        currency: 'EUR',
        image: remoteSupportImage,
        category: 'support',
        commercial: true,
        fulfilmentType: 'service',
        requestsImmediateStart: true,
        includedServiceKeys: ['weekdaySupport', 'antivirus', 'welcomeService'],
        variants: [
            {
                id: '60-months',
                durationMonths: 60,
                priceMinor: 99900,
                referencePriceMinor: 139900,
                savingsMinor: 40000,
                discountPercent: 29,
                bestValue: true,
                stripePaymentLink: smartCarePaymentLinks.sixtyMonths
            },
            {
                id: '36-months',
                durationMonths: 36,
                priceMinor: 69900,
                referencePriceMinor: 99900,
                savingsMinor: 30000,
                discountPercent: 30,
                stripePaymentLink: smartCarePaymentLinks.thirtySixMonths
            },
            {
                id: '12-months',
                durationMonths: 12,
                priceMinor: 39900,
                referencePriceMinor: 54900,
                savingsMinor: 15000,
                discountPercent: 27,
                stripePaymentLink: smartCarePaymentLinks.twelveMonths
            },
            {
                id: '6-months',
                durationMonths: 6,
                priceMinor: 24900,
                referencePriceMinor: 34900,
                savingsMinor: 10000,
                discountPercent: 29,
                stripePaymentLink: smartCarePaymentLinks.sixMonths
            }
        ]
    },
    {
        id: 'total-care-vip',
        slug: 'total-care-vip',
        nameKey: 'products.totalCareVip.name',
        descriptionKey: 'products.totalCareVip.description',
        shortDescriptionKey: 'products.totalCareVip.shortDescription',
        availability: 'available',
        priceMinor: 34900,
        currency: 'EUR',
        image: remoteSupportImage,
        category: 'support',
        commercial: true,
        fulfilmentType: 'service',
        requestsImmediateStart: true,
        includedServiceKeys: [
            'extendedSupport',
            'priority',
            'referenceTechnician',
            'antivirus',
            'monthlyMaintenance',
            'transferable',
            'welcomeService'
        ],
        variants: [
            {
                id: '60-months',
                durationMonths: 60,
                priceMinor: 139900,
                referencePriceMinor: 189900,
                savingsMinor: 50000,
                discountPercent: 26,
                bestValue: true,
                stripePaymentLink: totalCareVipPaymentLinks.sixtyMonths
            },
            {
                id: '36-months',
                durationMonths: 36,
                priceMinor: 99900,
                referencePriceMinor: 139900,
                savingsMinor: 40000,
                discountPercent: 29,
                stripePaymentLink: totalCareVipPaymentLinks.thirtySixMonths
            },
            {
                id: '12-months',
                durationMonths: 12,
                priceMinor: 59900,
                referencePriceMinor: 84900,
                savingsMinor: 25000,
                discountPercent: 29,
                stripePaymentLink: totalCareVipPaymentLinks.twelveMonths
            },
            {
                id: '6-months',
                durationMonths: 6,
                priceMinor: 34900,
                referencePriceMinor: 49900,
                savingsMinor: 15000,
                discountPercent: 30,
                stripePaymentLink: totalCareVipPaymentLinks.sixMonths
            }
        ]
    },
    {
        id: 'personal-care-360',
        slug: 'personal-care-360',
        nameKey: 'products.personalCare360.name',
        descriptionKey: 'products.personalCare360.description',
        shortDescriptionKey: 'products.personalCare360.shortDescription',
        availability: 'available',
        priceMinor: PERSONAL_CARE_TWELVE_MONTH_PRICE_MINOR,
        currency: 'EUR',
        image: personalCare360Image,
        category: 'support',
        commercial: true,
        fulfilmentType: 'service',
        requestsImmediateStart: true,
        includedServiceKeys: [
            'dedicatedConsultant',
            'unlimitedSupport',
            'downtime',
            'tailoredSetup',
            'activeProtection',
            'guidedLearning',
            'mobileSupport',
            'purchaseAdvice',
            'scamCheck',
            'backups',
            'preferredContact',
            'proactiveMaintenance',
            'humanSupervisedAi',
            'welcomeService'
        ],
        featured: false,
        variants: personalCareVariants.map((variant) => ({
            ...variant,
            ...(variant.id === personalCareBestValueId ? { bestValue: true } : {})
        }))
    }
];
export const featuredProducts = products.filter((product) => product.featured);
export const getProductBySlug = (slug) => products.find((product) => product.slug === slug);
